import {lazy} from 'react';

export const ComparisonTableLazy = lazy(() => import(/* webpackChunkName: "comparisonTable" */ '.'));
